module.exports = __webpack_public_path__ + "img/role04.83cc060c.png";